import { ContentWithEyeColumn } from 'components/TableColumn/ContentWithEyeColumn';
import { useCallback, useContext, useMemo, useRef, useState } from 'react';
import i18n from 'i18n';
import { Overlay } from 'react-bootstrap';
import { omit } from 'lodash';
import { Pmp } from 'core/pmp/Pmp';
import refContext from 'contexts/refContext';
import { InfoModal } from 'components/InfoModal/InfoModal';
import styles from './pmpDevicesColumn.module.scss';

export const PmpDevicesColumn: React.FC<{
  pmp: Pmp;
  deviceOptions: SelectOptions[];
}> = ({ pmp, deviceOptions }) => {
  const [showDevices, setShowDevices] = useState<boolean>(false);

  const target = useRef<HTMLDivElement>(null);
  const showDetailModal = useCallback(() => {
    setShowDevices(true);
  }, []);

  const hideDetailModal = useCallback(() => {
    setShowDevices(false);
  }, []);

  const refContextValue = useContext(refContext);

  const tooltipProps = useMemo(
    () => ({
      id: `faEye-tooltip-${pmp.id}`,
      tooltip: i18n.t('pmpList.buttons.showDevices')
    }),
    [pmp]
  );

  const devices = useMemo(
    () =>
      pmp.spaces.map((space) => {
        const deviceOption = deviceOptions.find(
          (option) => option.value === space
        );
        const deviceName = deviceOption ? deviceOption.label : space;
        return (
          <>
            {deviceName}
            <br />
          </>
        );
      }),
    [pmp, deviceOptions]
  );

  return (
    <div ref={target}>
      <ContentWithEyeColumn
        value={i18n.t('pmpList.labels.devicesInfo')}
        onClickBtn={showDetailModal}
        tooltipProps={tooltipProps}
      />
      <Overlay
        target={target}
        container={refContextValue?.ref}
        show={showDevices}
        placement='bottom'
      >
        {(props) => {
          return (
            <div
              {...omit(props, ['placement', 'arrowProps', 'show', 'popper'])}
              style={{
                ...props.style,
                width: '500px',
                zIndex: 100
              }}
            >
              <InfoModal
                className={styles.devicesModal}
                onClose={hideDetailModal}
              >
                <div className={styles.devicesModalContent}>{devices}</div>
              </InfoModal>
            </div>
          );
        }}
      </Overlay>
    </div>
  );
};

export const renderPmpDeviceColumn = (
  pmp: Pmp,
  deviceOptions: SelectOptions[]
) => {
  return <PmpDevicesColumn pmp={pmp} deviceOptions={deviceOptions} />;
};
